import { LoadingIcon } from '@assets/icons';
import { UMAP, useDeleteUMAPMutation } from '@generated/graphql';
import { Box, useTheme } from '@mui/material';
import { useNotifications } from '@notifications/Notifications';
import { UmapLoadingDatasetsRow, UmapLoadingHeader } from '@subsets/workspaces';
import { navigate } from 'gatsby';

interface UmapLoadingProps {
  workspaceId: string;
  fitDatasetId: string;
  umapLoading: boolean;
  datasets: UMAP['datasets'];
  samples: number[];
  status: string;
  umapId: string;
}

export const UmapLoading = ({
  status,
  datasets,
  umapLoading,
  samples,
  workspaceId,
  umapId,
  fitDatasetId,
}: UmapLoadingProps) => {
  const { palette } = useTheme();
  const [deleteUmapQuery] = useDeleteUMAPMutation();
  const { createAsyncNotification } = useNotifications();

  const deleteUmap = createAsyncNotification('Terminating', async () => {
    try {
      await deleteUmapQuery({ variables: { workspaceId, umapId } });
      navigate(-1);
    } catch {
      throw new Error('Termination interrupted');
    }
  });
  const isCompletedUmapLoading =
    (umapLoading && (status === undefined || status === null)) ||
    (umapLoading && status === 'completed');

  return (
    <Box height="100%" bgcolor={palette.background.paper} p={4}>
      {isCompletedUmapLoading ? (
        <LoadingIcon size={12} />
      ) : (
        <UmapLoadingHeader type={status} onCancel={deleteUmap} />
      )}
      <UmapLoadingDatasetsRow datasets={datasets} samples={samples} fitDatasetId={fitDatasetId} />
    </Box>
  );
};
